import { FunctionComponent, useEffect, useMemo, useState } from 'react';

import { SxProps, Typography } from '@mui/material';

import { useAppSelector } from '../../../store/hooks';
import { DEFAULT_TIME_ZONE } from '../../../utils/time-zone-utils';

const Clock: FunctionComponent<SxProps> = (sx) => {
  const { profile } = useAppSelector((gs) => gs.systemProfileState);
  const [timestamp, setTimestamp] = useState(() => Date.now());

  const clockFormatter = useMemo(() => {
    const timeZone = profile?.displayTimeZone ?? DEFAULT_TIME_ZONE;
    return new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone
    });
  }, [profile]);

  const formatClockValue = (timestamp: number) => clockFormatter.format(new Date(timestamp));

  useEffect(() => {
    const interval = setInterval(() => setTimestamp(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Typography variant="body2" component="div" sx={{ fontWeight: 500, whiteSpace: 'nowrap', ...sx }}>
      {formatClockValue(timestamp)}
    </Typography>
  );
};

export default Clock;
